import { uiSize } from '@utils'

interface Props {
  size?: number
}

function BankOutlineIcon({ size = 16 }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path d='M3 10l9-6 9 6M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18' />
    </svg>
  )
}

export default BankOutlineIcon
